import React from 'react';
import { HeroFullOverlay } from '@cotyorg/ccx-organism-hero';

export const HeroGirls = () => (
  <div className="hero-girls">
    <div className="grid-x">
      <div className="cell small-16 medium-10 medium-offset-3">
        <HeroFullOverlay
          heroStoreDataKey="girlsHero"
          theme="secondary"
          isUnderlined={false}
          isContentFirst
          layout="portrait"
        />
      </div>
    </div>
  </div>
);
